module.exports = __webpack_public_path__ + "img/matrix_item.f10c057a.png";